import SizeConversion from '@/components/common/size-conversion/SizeConversion';
import Breadcrumbs from "@/components/common/BreadCrumb";
import { getPostsByTopicUrlName } from "@/app/api/post/postAPI";
import PostList from "@/components/client/bang-gia";
import { getDynamicPageConfig } from './priceService';
import PageHeader from "@/components/common/page-header";

export default async function Page({ params }) {
    const { priceListUrl } = params;
    const urlName = `/${priceListUrl}`;

    const [pageConfig, response] = await Promise.all([
        getDynamicPageConfig(),
        getPostsByTopicUrlName(urlName, 0).catch(err => {
            console.error("Lỗi fetch posts:", err);
            return null;
        })
    ]);

    const currentPageConfig = pageConfig[priceListUrl];
    const currentTitle = currentPageConfig?.title || "Bảng giá";

    let initialData = response?.data?.data || { content: [], hasNext: false, totalElements: 0 };

    const paths = [
        { name: "TRANG CHỦ", url: "/" }
    ];

    if (priceListUrl === "bang-gia-van-tai-hang-hoa") {
        paths.push({ name: currentTitle.toUpperCase() });
    } else {
        paths.push({ name: "BẢNG GIÁ VẬN TẢI HÀNG HÓA", url: "/bang-gia-van-tai-hang-hoa" });
        paths.push({ name: currentTitle.toUpperCase() });
    }

    return (
        <>
            <PageHeader title={currentTitle} />
            <div className="container-fluid mt-5">
                <Breadcrumbs paths={paths} />
            </div>
            <hr className="w-full border-t-2 border-gray-300" />
            <PostList 
                initialPosts={initialData.content}
                initialHasNext={initialData.hasNext}
                initialTotalElements={initialData.totalElements}
                urlName={urlName}
            />
            <div className="container-fluid block-content mt-2">
                <SizeConversion />
            </div>
        </>
    );
}